/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  TriggerSyndigoSyncMutationResponse,
  TriggerSyndigoSyncPathParams,
  TriggerSyndigoSync400,
  TriggerSyndigoSync404,
} from '../types/TriggerSyndigoSync'

function getTriggerSyndigoSyncUrl({
  variant_id,
}: {
  variant_id: TriggerSyndigoSyncPathParams['variant_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/${variant_id}/syndigo/sync/` as const,
  }
  return res
}

/**
 * @description Trigger Syndigo sync for a specific variant via use case.
 * Args:
 * request: HTTP request
 * variant_id: ID of the variant to sync (from URL)
 * Returns:
 * Response with sync run details
 * @summary Trigger Syndigo sync for a variant
 * {@link /api/v1/products/catalog/variants/:variant_id/syndigo/sync/}
 */
export async function triggerSyndigoSync(
  { variant_id }: { variant_id: TriggerSyndigoSyncPathParams['variant_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    TriggerSyndigoSyncMutationResponse,
    ResponseErrorConfig<TriggerSyndigoSync400 | TriggerSyndigoSync404>,
    unknown
  >({
    method: 'POST',
    url: getTriggerSyndigoSyncUrl({ variant_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
